// if (!customElements.get("m-brand-list")) {
//   class MBrandList extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       const enableSlider = this.dataset.enableSlider === "true";
//       if (!enableSlider) return;
//       const wrapper = this.querySelector("[data-wrapper]");
//       wrapper.classList.add("swiper-wrapper");
//       this.initSlider();
//     }

//     initSlider() {
//       const autoplay = this.dataset.enableAutoplay === "true";
//       const autoplaySpeed = this.dataset.autoplaySpeed;
//       const items = parseInt(this.dataset.items);
//       const slideContainer = this.querySelector(".swiper-container");
//       if (slideContainer) {
//         this.slider = new MinimogLibs.Swiper(slideContainer, {
//           slidesPerView: 2,
//           slidesPerGroup: 1,
//           autoplay: autoplay
//             ? {
//                 delay: parseInt(autoplaySpeed) * 1000,
//               }
//             : false,
//           loop: true,
//           navigation: {
//             nextEl: this.querySelector(".swiper-button-next"),
//             prevEl: this.querySelector(".swiper-button-prev"),
//           },
//           pagination: {
//             el: this.querySelector(".swiper-pagination"),
//             clickable: true,
//           },
//           breakpoints: {
//             768: {
//               slidesPerView: items > 3 ? 3 : items,
//             },
//             1024: {
//               slidesPerView: items,
//             },
//           },
//         });
//       }
//     }
//   }

//   customElements.define("m-brand-list", MBrandList);
// }


if (!customElements.get("m-brand-list")) {
    class MBrandList extends HTMLElement {
        constructor() {
            super();
            this.currentIndex = 0;
            this.isZoomed = false;
            this.scale = 1;
            this.panX = 0;
            this.panY = 0;
            this.isDragging = false;
            this.startX = 0;
            this.startY = 0;
            this.touchStartX = 0;
            this.touchStartY = 0;
            this.lastTapTime = 0;

            this.boundKeydown = this.handleKeydown.bind(this);
        }

        connectedCallback() {
            const enableSlider = this.dataset.enableSlider === "true";
            if (enableSlider) {
                const wrapper = this.querySelector("[data-wrapper]");
                if (wrapper) wrapper.classList.add("swiper-wrapper");
                this.initSlider();
            }

            const enableZoom = this.dataset.enableZoom !== "false";
            if (enableZoom) {
                this.initLightbox();
            }
        }

        disconnectedCallback() {
            document.removeEventListener("keydown", this.boundKeydown);
            if (this.lightboxEl && this.lightboxEl.parentNode === document.body) {
                document.body.removeChild(this.lightboxEl);
            }
        }

        initSlider() {
            const autoplay = this.dataset.enableAutoplay === "true";
            const autoplaySpeed = this.dataset.autoplaySpeed;
            const items = parseInt(this.dataset.items) || 4;
            const slideContainer = this.querySelector(".swiper-container");
            if (slideContainer && window.MinimogLibs && window.MinimogLibs.Swiper) {
                this.slider = new MinimogLibs.Swiper(slideContainer, {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    autoplay: autoplay
                        ? {
                            delay: parseInt(autoplaySpeed) * 1000,
                        }
                        : false,
                    loop: true,
                    navigation: {
                        nextEl: this.querySelector(".swiper-button-next"),
                        prevEl: this.querySelector(".swiper-button-prev"),
                    },
                    pagination: {
                        el: this.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: items > 3 ? 3 : items,
                        },
                        1024: {
                            slidesPerView: items,
                        },
                    },
                });
            }
        }

        initLightbox() {
            const triggers = Array.from(this.querySelectorAll("[data-zoom-trigger]"));
            if (!triggers.length) return;

            // Collect unique images or block data
            this.galleryItems = [];
            triggers.forEach((trigger, idx) => {
                const fullSrc = trigger.getAttribute("data-full-src") || trigger.querySelector("img")?.src || "";
                const alt = trigger.getAttribute("data-alt") || trigger.querySelector("img")?.alt || "";
                const dataIndex = trigger.getAttribute("data-index");
                const itemIndex = dataIndex !== null ? parseInt(dataIndex, 10) : idx;

                this.galleryItems.push({
                    src: fullSrc,
                    alt: alt,
                    index: itemIndex
                });

                // Attach click & enter key event
                const handleOpen = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openLightbox(itemIndex);
                };

                trigger.addEventListener("click", handleOpen);
                trigger.addEventListener("keydown", (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        handleOpen(e);
                    }
                });
            });

            // Find lightbox modal in the section and move to body
            this.lightboxEl = this.querySelector(".m-gallery-lightbox");
            if (!this.lightboxEl) return;

            // Ensure modal escapes any parent CSS overflow / stacking contexts
            if (this.lightboxEl.parentNode !== document.body) {
                document.body.appendChild(this.lightboxEl);
            }

            // Cache lightbox DOM references
            this.lightboxImg = this.lightboxEl.querySelector("[data-lightbox-img]");
            this.lightboxWrapper = this.lightboxEl.querySelector("[data-lightbox-wrapper]");
            this.lightboxStage = this.lightboxEl.querySelector("[data-lightbox-stage]");
            this.lightboxLoader = this.lightboxEl.querySelector("[data-lightbox-loader]");
            this.lightboxCounter = this.lightboxEl.querySelector("[data-lightbox-counter]");
            this.lightboxCaption = this.lightboxEl.querySelector("[data-lightbox-caption]");
            this.lightboxPrevBtn = this.lightboxEl.querySelector("[data-lightbox-prev]");
            this.lightboxNextBtn = this.lightboxEl.querySelector("[data-lightbox-next]");
            this.lightboxZoomBtn = this.lightboxEl.querySelector("[data-lightbox-zoom-toggle]");
            this.iconZoomIn = this.lightboxEl.querySelector(".m-icon-zoom-in");
            this.iconZoomOut = this.lightboxEl.querySelector(".m-icon-zoom-out");

            // Attach event listeners for controls
            const closeElements = this.lightboxEl.querySelectorAll("[data-lightbox-close]");
            closeElements.forEach((el) => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.closeLightbox();
                });
            });

            if (this.lightboxPrevBtn) {
                this.lightboxPrevBtn.addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.prevImage();
                });
            }

            if (this.lightboxNextBtn) {
                this.lightboxNextBtn.addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.nextImage();
                });
            }

            if (this.lightboxZoomBtn) {
                this.lightboxZoomBtn.addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.toggleZoom();
                });
            }

            // Double click to zoom on image
            if (this.lightboxWrapper) {
                this.lightboxWrapper.addEventListener("dblclick", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.toggleZoom(e.clientX, e.clientY);
                });
            }

            // Panning with mouse drag when zoomed
            if (this.lightboxWrapper) {
                this.lightboxWrapper.addEventListener("mousedown", (e) => {
                    if (!this.isZoomed || e.button !== 0) return;
                    this.isDragging = true;
                    this.startX = e.clientX - this.panX;
                    this.startY = e.clientY - this.panY;
                    this.lightboxWrapper.classList.add("is-panning");
                    e.preventDefault();
                });

                window.addEventListener("mousemove", (e) => {
                    if (!this.isDragging || !this.isZoomed) return;
                    this.panX = e.clientX - this.startX;
                    this.panY = e.clientY - this.startY;
                    this.applyTransform();
                });

                window.addEventListener("mouseup", () => {
                    if (this.isDragging) {
                        this.isDragging = false;
                        if (this.lightboxWrapper) {
                            this.lightboxWrapper.classList.remove("is-panning");
                        }
                    }
                });
            }

            // Touch Gestures on Mobile/Tablet
            if (this.lightboxStage) {
                this.lightboxStage.addEventListener("touchstart", (e) => {
                    if (e.touches.length === 1) {
                        this.touchStartX = e.touches[0].clientX;
                        this.touchStartY = e.touches[0].clientY;

                        // Double tap detection
                        const now = Date.now();
                        if (now - this.lastTapTime < 320) {
                            e.preventDefault();
                            this.toggleZoom(this.touchStartX, this.touchStartY);
                            this.lastTapTime = 0;
                            return;
                        }
                        this.lastTapTime = now;

                        // If already zoomed, prepare for touch panning
                        if (this.isZoomed) {
                            this.isDragging = true;
                            this.startX = this.touchStartX - this.panX;
                            this.startY = this.touchStartY - this.panY;
                        }
                    }
                }, { passive: false });

                this.lightboxStage.addEventListener("touchmove", (e) => {
                    if (this.isZoomed && this.isDragging && e.touches.length === 1) {
                        e.preventDefault();
                        this.panX = e.touches[0].clientX - this.startX;
                        this.panY = e.touches[0].clientY - this.startY;
                        this.applyTransform();
                    }
                }, { passive: false });

                this.lightboxStage.addEventListener("touchend", (e) => {
                    if (this.isDragging) {
                        this.isDragging = false;
                    }

                    if (!this.isZoomed && e.changedTouches.length === 1) {
                        const touchEndX = e.changedTouches[0].clientX;
                        const touchEndY = e.changedTouches[0].clientY;
                        const deltaX = touchEndX - this.touchStartX;
                        const deltaY = touchEndY - this.touchStartY;

                        // Swipe left / right to navigate
                        if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
                            if (deltaX < 0) {
                                this.nextImage();
                            } else {
                                this.prevImage();
                            }
                        }
                        // Swipe down to close
                        else if (deltaY > 80 && Math.abs(deltaY) > Math.abs(deltaX) * 1.8) {
                            this.closeLightbox();
                        }
                    }
                });
            }
        }

        openLightbox(index) {
            if (!this.lightboxEl) return;
            this.currentIndex = index;

            this.lightboxEl.classList.add("is-open");
            this.lightboxEl.setAttribute("aria-hidden", "false");

            // Prevent background page scrolling
            document.documentElement.classList.add("prevent-scroll");
            document.body.style.overflow = "hidden";

            this.loadImage(this.currentIndex);
            document.addEventListener("keydown", this.boundKeydown);
        }

        closeLightbox() {
            if (!this.lightboxEl) return;
            this.lightboxEl.classList.remove("is-open");
            this.lightboxEl.setAttribute("aria-hidden", "true");

            document.documentElement.classList.remove("prevent-scroll");
            document.body.style.overflow = "";

            this.resetZoom();
            document.removeEventListener("keydown", this.boundKeydown);
        }

        loadImage(index) {
            if (!this.galleryItems || !this.galleryItems.length) return;
            const item = this.galleryItems.find((itm) => itm.index === index) || this.galleryItems[index] || this.galleryItems[0];
            if (!item || !item.src) return;

            this.resetZoom();

            if (this.lightboxLoader) this.lightboxLoader.classList.add("is-loading");
            if (this.lightboxImg) {
                this.lightboxImg.classList.remove("is-loaded");
            }

            if (this.lightboxCounter) {
                const currentNum = this.galleryItems.findIndex((itm) => itm.index === item.index) + 1;
                this.lightboxCounter.textContent = `${currentNum} / ${this.galleryItems.length}`;
            }

            if (this.lightboxCaption) {
                this.lightboxCaption.textContent = item.alt || "";
            }

            // Load high-resolution image smoothly
            const tempImg = new Image();
            tempImg.src = item.src;
            tempImg.onload = () => {
                if (this.lightboxImg) {
                    this.lightboxImg.src = item.src;
                    this.lightboxImg.alt = item.alt || "";
                    this.lightboxImg.classList.add("is-loaded");
                }
                if (this.lightboxLoader) {
                    this.lightboxLoader.classList.remove("is-loading");
                }
            };
            tempImg.onerror = () => {
                if (this.lightboxImg) {
                    this.lightboxImg.src = item.src;
                    this.lightboxImg.classList.add("is-loaded");
                }
                if (this.lightboxLoader) {
                    this.lightboxLoader.classList.remove("is-loading");
                }
            };

            // Preload next image for instant transitions
            const nextIdx = (this.galleryItems.findIndex((itm) => itm.index === item.index) + 1) % this.galleryItems.length;
            const nextItem = this.galleryItems[nextIdx];
            if (nextItem && nextItem.src) {
                const preloadImg = new Image();
                preloadImg.src = nextItem.src;
            }
        }

        nextImage() {
            if (!this.galleryItems || this.galleryItems.length <= 1) return;
            const currentPos = this.galleryItems.findIndex((itm) => itm.index === this.currentIndex);
            const nextPos = (currentPos + 1) % this.galleryItems.length;
            this.currentIndex = this.galleryItems[nextPos].index;
            this.loadImage(this.currentIndex);
        }

        prevImage() {
            if (!this.galleryItems || this.galleryItems.length <= 1) return;
            const currentPos = this.galleryItems.findIndex((itm) => itm.index === this.currentIndex);
            const prevPos = (currentPos - 1 + this.galleryItems.length) % this.galleryItems.length;
            this.currentIndex = this.galleryItems[prevPos].index;
            this.loadImage(this.currentIndex);
        }

        toggleZoom(originX, originY) {
            if (!this.isZoomed) {
                this.isZoomed = true;
                this.scale = 2.2;
                if (originX !== undefined && originY !== undefined && this.lightboxWrapper) {
                    const rect = this.lightboxWrapper.getBoundingClientRect();
                    const offsetX = originX - (rect.left + rect.width / 2);
                    const offsetY = originY - (rect.top + rect.height / 2);
                    this.panX = -offsetX * 1.2;
                    this.panY = -offsetY * 1.2;
                } else {
                    this.panX = 0;
                    this.panY = 0;
                }
                if (this.lightboxWrapper) this.lightboxWrapper.classList.add("is-zoomed");
                if (this.iconZoomIn) this.iconZoomIn.style.display = "none";
                if (this.iconZoomOut) this.iconZoomOut.style.display = "block";
            } else {
                this.resetZoom();
            }
            this.applyTransform();
        }

        resetZoom() {
            this.isZoomed = false;
            this.scale = 1;
            this.panX = 0;
            this.panY = 0;
            if (this.lightboxWrapper) {
                this.lightboxWrapper.classList.remove("is-zoomed", "is-panning");
                this.lightboxWrapper.style.transform = "";
            }
            if (this.iconZoomIn) this.iconZoomIn.style.display = "block";
            if (this.iconZoomOut) this.iconZoomOut.style.display = "none";
        }

        applyTransform() {
            if (!this.lightboxWrapper) return;
            if (this.isZoomed) {
                // Limit maximum panning boundaries
                const maxPan = 400;
                this.panX = Math.max(-maxPan, Math.min(maxPan, this.panX));
                this.panY = Math.max(-maxPan, Math.min(maxPan, this.panY));
                this.lightboxWrapper.style.transform = `translate(${this.panX}px, ${this.panY}px) scale(${this.scale})`;
            } else {
                this.lightboxWrapper.style.transform = "";
            }
        }

        handleKeydown(e) {
            if (!this.lightboxEl || !this.lightboxEl.classList.contains("is-open")) return;
            if (e.key === "Escape") {
                e.preventDefault();
                this.closeLightbox();
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                this.nextImage();
            } else if (e.key === "ArrowLeft") {
                e.preventDefault();
                this.prevImage();
            }
        }
    }

    customElements.define("m-brand-list", MBrandList);
}

